"use client";

import { useSelector } from "react-redux";
import React from "react";

import styles from "./header.module.scss";

const tabs = [
  {
    title: "Rewards",
    param: "",
  },
  {
    title: "Claim history",
    param: "history",
  },
  {
    title: "Earn points",
    param: "cipherpoints",
  },
];

const HeaderTab = (props) => {
  const { title, param, func, active } = props;

  return (
    <a
      id={`Reward_Page_${title}_Btn`}
      className={`${active ? styles.active : ""} ${styles.tab}`}
      href={func(param)}
    >
      {title}
    </a>
  );
};

const Header = (props) => {
  const user = useSelector((state) => state.user.users);
  const { type } = props;

  const handleClick = (tab) => {
    if (user?.email) return `/rewards/${tab}`;
    else return "/rewards?login=true";
  };

  return (
    <header className={styles.header}>
      {tabs.map((tab, i) => (
        <HeaderTab
          key={i}
          {...tab}
          func={handleClick}
          active={tab.param === type}
        />
      ))}
    </header>
  );
};

export default Header;
